import { vars } from '@repo/config';
import { createPostFetchOptions } from './helper';

interface ICreateUserParams {
  email: string;
  role: string;
}

interface ICreateUserResponse {
  success: boolean;
  error?: string;
}

export async function createUser(
  cookieHeader: string,
  params: ICreateUserParams,
): Promise<ICreateUserResponse> {
  const createUrl = new URL('/api/auth/admin/create-user', vars.url.identityUrl);
  const response = await fetch(
    createUrl.toString(),
    createPostFetchOptions({
      cookieHeader,
      body: {
        email: params.email,
        role: params.role,
        name: params.email.split('@')[0],
        password: crypto.randomUUID(),
      },
    }),
  );

  if (!response.ok) {
    const errorData = (await response.json()) as { message?: string };
    return { success: false, error: errorData.message || 'Failed to create user' };
  }

  return { success: true };
}
